const compatModules = {};import * as Mod1 from "./discourse/controllers/admin-plugins-proxyviews-seo";
compatModules["discourse/controllers/admin-plugins-proxyviews-seo"] = Mod1;

export * as discourse$controllers$admin__plugins__proxyviews__seo$$__module from "./discourse/controllers/admin-plugins-proxyviews-seo";
export {
default as discourse$controllers$admin__plugins__proxyviews__seo$$default
} from "./discourse/controllers/admin-plugins-proxyviews-seo";
import * as Mod2 from "./discourse/controllers/admin-plugins/proxyviews-seo";
compatModules["discourse/controllers/admin-plugins/proxyviews-seo"] = Mod2;

export * as discourse$controllers$admin__plugins$proxyviews__seo$$__module from "./discourse/controllers/admin-plugins/proxyviews-seo";
export {
default as discourse$controllers$admin__plugins$proxyviews__seo$$default
} from "./discourse/controllers/admin-plugins/proxyviews-seo";
import * as Mod3 from "./discourse/initializers/seo";
compatModules["discourse/initializers/seo"] = Mod3;

export * as discourse$initializers$seo$$__module from "./discourse/initializers/seo";
export {
default as discourse$initializers$seo$$default
} from "./discourse/initializers/seo";
import * as Mod4 from "./discourse/lib/proxyviews-seo";
compatModules["discourse/lib/proxyviews-seo"] = Mod4;

export * as discourse$lib$proxyviews__seo$$__module from "./discourse/lib/proxyviews-seo";
export {
RANK_CLASS as discourse$lib$proxyviews__seo$$RANK_CLASS,
decorateRegionalPerformance as discourse$lib$proxyviews__seo$$decorateRegionalPerformance
} from "./discourse/lib/proxyviews-seo";
import * as Mod5 from "./discourse/proxyviews-seo-route-map";
compatModules["discourse/proxyviews-seo-route-map"] = Mod5;

export * as discourse$proxyviews__seo__route__map$$__module from "./discourse/proxyviews-seo-route-map";
export {
default as discourse$proxyviews__seo__route__map$$default
} from "./discourse/proxyviews-seo-route-map";
import * as Mod6 from "./discourse/routes/admin-plugins-proxyviews-seo";
compatModules["discourse/routes/admin-plugins-proxyviews-seo"] = Mod6;

export * as discourse$routes$admin__plugins__proxyviews__seo$$__module from "./discourse/routes/admin-plugins-proxyviews-seo";
export {
default as discourse$routes$admin__plugins__proxyviews__seo$$default
} from "./discourse/routes/admin-plugins-proxyviews-seo";
import * as Mod7 from "./discourse/routes/admin-plugins/proxyviews-seo";
compatModules["discourse/routes/admin-plugins/proxyviews-seo"] = Mod7;

export * as discourse$routes$admin__plugins$proxyviews__seo$$__module from "./discourse/routes/admin-plugins/proxyviews-seo";
export {
default as discourse$routes$admin__plugins$proxyviews__seo$$default
} from "./discourse/routes/admin-plugins/proxyviews-seo";
import * as Mod8 from "./discourse/routes/proxyviews-alternatives";
compatModules["discourse/routes/proxyviews-alternatives"] = Mod8;

export * as discourse$routes$proxyviews__alternatives$$__module from "./discourse/routes/proxyviews-alternatives";
export {
default as discourse$routes$proxyviews__alternatives$$default
} from "./discourse/routes/proxyviews-alternatives";
import * as Mod9 from "./discourse/routes/proxyviews-best-for-index";
compatModules["discourse/routes/proxyviews-best-for-index"] = Mod9;

export * as discourse$routes$proxyviews__best__for__index$$__module from "./discourse/routes/proxyviews-best-for-index";
export {
default as discourse$routes$proxyviews__best__for__index$$default
} from "./discourse/routes/proxyviews-best-for-index";
import * as Mod10 from "./discourse/routes/proxyviews-best-for";
compatModules["discourse/routes/proxyviews-best-for"] = Mod10;

export * as discourse$routes$proxyviews__best__for$$__module from "./discourse/routes/proxyviews-best-for";
export {
default as discourse$routes$proxyviews__best__for$$default
} from "./discourse/routes/proxyviews-best-for";
import * as Mod11 from "./discourse/routes/proxyviews-comparison";
compatModules["discourse/routes/proxyviews-comparison"] = Mod11;

export * as discourse$routes$proxyviews__comparison$$__module from "./discourse/routes/proxyviews-comparison";
export {
default as discourse$routes$proxyviews__comparison$$default
} from "./discourse/routes/proxyviews-comparison";
import * as Mod12 from "./discourse/routes/proxyviews-geo-city";
compatModules["discourse/routes/proxyviews-geo-city"] = Mod12;

export * as discourse$routes$proxyviews__geo__city$$__module from "./discourse/routes/proxyviews-geo-city";
export {
default as discourse$routes$proxyviews__geo__city$$default
} from "./discourse/routes/proxyviews-geo-city";
import * as Mod13 from "./discourse/routes/proxyviews-geo";
compatModules["discourse/routes/proxyviews-geo"] = Mod13;

export * as discourse$routes$proxyviews__geo$$__module from "./discourse/routes/proxyviews-geo";
export {
default as discourse$routes$proxyviews__geo$$default
} from "./discourse/routes/proxyviews-geo";
import * as Mod14 from "./discourse/routes/proxyviews-glossary-term";
compatModules["discourse/routes/proxyviews-glossary-term"] = Mod14;

export * as discourse$routes$proxyviews__glossary__term$$__module from "./discourse/routes/proxyviews-glossary-term";
export {
default as discourse$routes$proxyviews__glossary__term$$default
} from "./discourse/routes/proxyviews-glossary-term";
import * as Mod15 from "./discourse/routes/proxyviews-glossary";
compatModules["discourse/routes/proxyviews-glossary"] = Mod15;

export * as discourse$routes$proxyviews__glossary$$__module from "./discourse/routes/proxyviews-glossary";
export {
default as discourse$routes$proxyviews__glossary$$default
} from "./discourse/routes/proxyviews-glossary";
import * as Mod16 from "./discourse/routes/proxyviews-guide";
compatModules["discourse/routes/proxyviews-guide"] = Mod16;

export * as discourse$routes$proxyviews__guide$$__module from "./discourse/routes/proxyviews-guide";
export {
default as discourse$routes$proxyviews__guide$$default
} from "./discourse/routes/proxyviews-guide";
import * as Mod17 from "./discourse/routes/proxyviews-guides";
compatModules["discourse/routes/proxyviews-guides"] = Mod17;

export * as discourse$routes$proxyviews__guides$$__module from "./discourse/routes/proxyviews-guides";
export {
default as discourse$routes$proxyviews__guides$$default
} from "./discourse/routes/proxyviews-guides";
import * as Mod18 from "./discourse/templates/admin-plugins-proxyviews-seo";
compatModules["discourse/templates/admin-plugins-proxyviews-seo"] = Mod18;

export * as discourse$templates$admin__plugins__proxyviews__seo$$__module from "./discourse/templates/admin-plugins-proxyviews-seo";
export {
default as discourse$templates$admin__plugins__proxyviews__seo$$default
} from "./discourse/templates/admin-plugins-proxyviews-seo";
import * as Mod19 from "./discourse/templates/admin-plugins/proxyviews-seo";
compatModules["discourse/templates/admin-plugins/proxyviews-seo"] = Mod19;

export * as discourse$templates$admin__plugins$proxyviews__seo$$__module from "./discourse/templates/admin-plugins/proxyviews-seo";
export {
default as discourse$templates$admin__plugins$proxyviews__seo$$default
} from "./discourse/templates/admin-plugins/proxyviews-seo";
import * as Mod20 from "./discourse/templates/proxyviews-alternatives";
compatModules["discourse/templates/proxyviews-alternatives"] = Mod20;

export * as discourse$templates$proxyviews__alternatives$$__module from "./discourse/templates/proxyviews-alternatives";
export {
default as discourse$templates$proxyviews__alternatives$$default
} from "./discourse/templates/proxyviews-alternatives";
import * as Mod21 from "./discourse/templates/proxyviews-best-for-index";
compatModules["discourse/templates/proxyviews-best-for-index"] = Mod21;

export * as discourse$templates$proxyviews__best__for__index$$__module from "./discourse/templates/proxyviews-best-for-index";
export {
default as discourse$templates$proxyviews__best__for__index$$default
} from "./discourse/templates/proxyviews-best-for-index";
import * as Mod22 from "./discourse/templates/proxyviews-best-for";
compatModules["discourse/templates/proxyviews-best-for"] = Mod22;

export * as discourse$templates$proxyviews__best__for$$__module from "./discourse/templates/proxyviews-best-for";
export {
default as discourse$templates$proxyviews__best__for$$default
} from "./discourse/templates/proxyviews-best-for";
import * as Mod23 from "./discourse/templates/proxyviews-comparison";
compatModules["discourse/templates/proxyviews-comparison"] = Mod23;

export * as discourse$templates$proxyviews__comparison$$__module from "./discourse/templates/proxyviews-comparison";
export {
default as discourse$templates$proxyviews__comparison$$default
} from "./discourse/templates/proxyviews-comparison";
import * as Mod24 from "./discourse/templates/proxyviews-geo-city";
compatModules["discourse/templates/proxyviews-geo-city"] = Mod24;

export * as discourse$templates$proxyviews__geo__city$$__module from "./discourse/templates/proxyviews-geo-city";
export {
default as discourse$templates$proxyviews__geo__city$$default
} from "./discourse/templates/proxyviews-geo-city";
import * as Mod25 from "./discourse/templates/proxyviews-geo";
compatModules["discourse/templates/proxyviews-geo"] = Mod25;

export * as discourse$templates$proxyviews__geo$$__module from "./discourse/templates/proxyviews-geo";
export {
default as discourse$templates$proxyviews__geo$$default
} from "./discourse/templates/proxyviews-geo";
import * as Mod26 from "./discourse/templates/proxyviews-glossary-term";
compatModules["discourse/templates/proxyviews-glossary-term"] = Mod26;

export * as discourse$templates$proxyviews__glossary__term$$__module from "./discourse/templates/proxyviews-glossary-term";
export {
default as discourse$templates$proxyviews__glossary__term$$default
} from "./discourse/templates/proxyviews-glossary-term";
import * as Mod27 from "./discourse/templates/proxyviews-glossary";
compatModules["discourse/templates/proxyviews-glossary"] = Mod27;

export * as discourse$templates$proxyviews__glossary$$__module from "./discourse/templates/proxyviews-glossary";
export {
default as discourse$templates$proxyviews__glossary$$default
} from "./discourse/templates/proxyviews-glossary";
import * as Mod28 from "./discourse/templates/proxyviews-guide";
compatModules["discourse/templates/proxyviews-guide"] = Mod28;

export * as discourse$templates$proxyviews__guide$$__module from "./discourse/templates/proxyviews-guide";
export {
default as discourse$templates$proxyviews__guide$$default
} from "./discourse/templates/proxyviews-guide";
import * as Mod29 from "./discourse/templates/proxyviews-guides";
compatModules["discourse/templates/proxyviews-guides"] = Mod29;

export * as discourse$templates$proxyviews__guides$$__module from "./discourse/templates/proxyviews-guides";
export {
default as discourse$templates$proxyviews__guides$$default
} from "./discourse/templates/proxyviews-guides";
export default compatModules;
